import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, PhoneOff, Video } from 'lucide-react';
import { useCall } from '../../context/CallContext';
import useRingTone from './useRingTone';
import './Calls.css';

export default function OutgoingCallModal() {
    const { status, call, aviso, cancelCall } = useCall();
    const visible = status === 'outgoing' && call;

    useRingTone(visible && !aviso, 'outgoing');

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    className="call-modal-backdrop"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    <motion.div
                        className="call-modal"
                        initial={{ scale: 0.85, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.85, opacity: 0 }}
                        transition={{ type: 'spring', stiffness: 260, damping: 22 }}
                    >
                        <div className="call-modal-type">
                            {call?.call_type === 'video' ? <Video size={18} /> : <Phone size={18} />}
                            <span>
                                {call?.call_type === 'video'
                                    ? 'Videollamada saliente'
                                    : 'Llamada saliente'}
                            </span>
                        </div>

                        <div className="call-modal-avatar">
                            {call?.callee_foto ? (
                                <img src={call.callee_foto} alt={call.callee_name} />
                            ) : (
                                <span>{call?.callee_name?.charAt(0).toUpperCase() || '?'}</span>
                            )}
                        </div>

                        <div className="call-modal-name">{call?.callee_name || 'Llamando...'}</div>
                        <div className="call-modal-status">
                            {aviso || 'Sonando...'}
                        </div>

                        {!aviso && (
                            <div className="call-modal-actions">
                                <button
                                    className="call-btn call-btn-reject"
                                    onClick={cancelCall}
                                    title="Cancelar"
                                >
                                    <PhoneOff size={26} />
                                </button>
                            </div>
                        )}
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
